import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { setUpZoomHandling } from './lib/viewport';
import './styles/global.css';

setUpZoomHandling();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
